export const dashboard = {
  en: {
    welcome: "Welcome back, {name}",
    position: "Position",
    department: "Department",
    branch: "Branch",
    directManager: "Direct manager",

    daysAttendedWithLate: "days attended · {n} late",
    daysPresentThisMonth: "days attended this month",
    awaitingDecision: "awaiting a decision",
    nOverdue: "{n} overdue",
    allOnTime: "nothing late",
    whatIsComing: "what is coming up",
    unread: "unread",

    recentRequests: "Recent requests",
    upcomingTasks: "Upcoming tasks",
    recentNotifications: "Recent notifications",
    nothingDue: "Nothing on your list.",
    noNotifications: "No notifications.",
    seeAll: "See all",

    // Notifications, per DEVICE — a subscription belongs to one browser on
    // one machine, which is what "this device" is saying.
    notifyTitle: "Notifications on this device",
    notifyWhy: "Get a reminder on this device when your shift starts and ends, so a forgotten punch is caught the same day.",
    notifyButton: "Turn on notifications",
    notifyBlocked: "Notifications are blocked for this site. Allow them in your browser's site settings, then come back.",
    notifyOn: "Notifications are on for this device.",
    notifyDevices: "{n} device(s) listening on your account:",
    notifyRemove: "Remove",
    notifyTest: "Send a test now",
    notifyOff: "Turn off on this device",
    notifySent: "Sent to {n} device(s).",
    notifyNoDevice: "No device accepted it. The subscription may have expired — turn it off and on again.",

    // Installing. Each route names the browser's own menu, because "install the
    // app" is not an instruction anybody can follow.
    installTitle: "Install Alba on this device",
    installWhy: "It opens in its own window, without the address bar, and starts from the home screen like any other app.",
    installButton: "Install",
    installIosSafari: "In Safari, tap Share at the bottom of the screen, then Add to Home Screen.",
    installMacosSafari: "In Safari, choose File ▸ Add to Dock.",
    installFirefoxDesktop: "Firefox on the desktop cannot install web apps. Open Alba in Chrome or Edge to install it, or keep using it in this tab — everything works either way.",
    installManual: "Look for Install or Add to Home Screen in your browser's menu. If it is not there, this browser cannot install web apps.",
    installOffline: "Once installed it opens without a connection, but it will say so rather than show you figures from yesterday.",
  },
  ar: {
    welcome: "أهلاً بعودتك، {name}",
    position: "المسمى الوظيفي",
    department: "القسم",
    branch: "الفرع",
    directManager: "المدير المباشر",

    daysAttendedWithLate: "يوم حضور · منها {n} تأخير",
    daysPresentThisMonth: "يوم حضور هذا الشهر",
    awaitingDecision: "بانتظار القرار",
    nOverdue: "{n} متأخرة",
    allOnTime: "لا يوجد متأخر",
    whatIsComing: "ما هو قادم",
    unread: "غير مقروء",

    recentRequests: "أحدث الطلبات",
    upcomingTasks: "المهام القادمة",
    recentNotifications: "أحدث الإشعارات",
    nothingDue: "لا توجد مهام على قائمتك.",
    noNotifications: "لا توجد إشعارات.",
    seeAll: "عرض الكل",

    notifyTitle: "إشعارات هذا الجهاز",
    notifyWhy: "يصلك تذكير على هذا الجهاز عند بداية دوامك ونهايته، فلا تمرّ بصمةٌ منسيّة إلى اليوم التالي.",
    notifyButton: "تفعيل الإشعارات",
    notifyBlocked: "الإشعارات محجوبة لهذا الموقع. اسمح بها من إعدادات الموقع في متصفحك ثم عُد.",
    notifyOn: "الإشعارات مفعّلة على هذا الجهاز.",
    notifyDevices: "الأجهزة المستقبِلة على حسابك ({n}):",
    notifyRemove: "حذف",
    notifyTest: "جرّب الآن",
    notifyOff: "إيقافها على هذا الجهاز",
    notifySent: "أُرسل إلى {n} من الأجهزة.",
    notifyNoDevice: "لم يقبله أي جهاز. قد يكون الاشتراك انتهى — أوقفه وفعّله من جديد.",
    installTitle: "ثبّت ألبا على هذا الجهاز",
    installWhy: "يفتح في نافذة خاصة به بدون شريط العناوين، ويبدأ من الشاشة الرئيسية مثل أي تطبيق آخر.",
    installButton: "تثبيت",
    installIosSafari: "في متصفح سفاري، اضغط على زر المشاركة أسفل الشاشة، ثم اختر إضافة إلى الشاشة الرئيسية.",
    installMacosSafari: "في متصفح سفاري، اختر ملف ثم إضافة إلى الشريط.",
    installFirefoxDesktop: "لا يمكن لمتصفح فايرفوكس على الحاسب تثبيت تطبيقات الويب. افتح ألبا في كروم أو إيدج للتثبيت، أو تابع استخدامه في هذه النافذة — كل شيء يعمل في الحالتين.",
    installManual: "ابحث عن خيار التثبيت أو الإضافة إلى الشاشة الرئيسية في قائمة المتصفح. إن لم يكن موجوداً فهذا المتصفح لا يدعم تثبيت تطبيقات الويب.",
    installOffline: "بعد التثبيت يفتح بدون اتصال، لكنه سيخبرك بذلك بدلاً من عرض أرقام قديمة.",
  },
} as const;
